import { Field, Text } from "@sitecore-jss/sitecore-jss-nextjs";
import clsx from "clsx";
import * as Flex from "@repo/ui/flex";
import { TYPOGRAPHY_BODY3 } from "@/theme/topshop-2/typography/typography-constants";
import styles from "./version-number.module.css";

export type VersionNumberProps = {
  versionNumber: Field<string>;
  lastUpdated: Field<string>;
};

const VersionNumber = (props: VersionNumberProps): JSX.Element => {
  const { versionNumber, lastUpdated } = props;

  return (
    <Flex.Container
      column
      justify="center"
      align="center"
      className={styles.versionNumberContainer}
    >
      <Text
        tag="span"
        field={versionNumber}
        className={clsx(styles.title, TYPOGRAPHY_BODY3)}
      />
      <Text
        tag="span"
        field={lastUpdated}
        className={clsx(styles.date, TYPOGRAPHY_BODY3)}
      />
    </Flex.Container>
  );
};

export default VersionNumber;
